import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import RouteLoader from "@/components/RouteLoader";
import { useHoverTicks } from "@/lib/useHoverTicks";
import { useIntroChime } from "@/lib/useIntroChime";
import HomePage from "@/pages/HomePage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ClientDashboard from "@/pages/ClientDashboard";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useHoverTicks();
  useIntroChime();
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster theme="dark" position="bottom-right" toastOptions={{
            style: { background: "#071733", border: "1px solid rgba(212,175,55,0.3)", color: "#fff" }
          }} />
          <RouteLoader />
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services/:slug" element={<ServiceDetailPage />} />
            <Route path="/portal/login" element={<LoginPage />} />
            <Route path="/portal/register" element={<RegisterPage />} />
            <Route path="/portal" element={
              <ProtectedRoute><ClientDashboard /></ProtectedRoute>
            } />
            <Route path="/admin" element={
              <ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
